// import React, { useEffect, useState } from "react";
// import "../assets/SalaryReport.css";
//  import axios from "axios";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";
// import { getBranches } from "../redux/slices/branchSlice";


// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";


// const SalaryReport = () => {
//   const dispatch = useDispatch();
//   const [selectedEmployee, setSelectedEmployee] = useState("");
//   const [selectedBranch, setSelectedBranch] = useState("");
//   const [selectedData,setSelecteddata]=useState([]);
//   const { list: data } = useSelector((state) => state.employeeReport);
//   const pageSize = 1000;
//   const superAdminId = localStorage.getItem("adminuserId") || "14";

//   const fetchData = (page = 1) => {
//     dispatch(fetchEmployeeReport({ page, pageSize }));
//     dispatch(getBranches({ page, pageSize }));
//   };

//   const { branches, totalRecords, loading, error } = useSelector(
//       (state) => state.branch
//     );

//   useEffect(() => {
//     fetchData(1);
//   }, []);

// const getSalaryStructures = async () => {
//   try {
//     const params = { superAdminId };

//     if (selectedBranch) params.branchId = selectedBranch;
//     if (selectedEmployee) params.employeeId = selectedEmployee;

//     const response = await axios.get(
//       "https://narrowitsolution.in/api/salary-structures",
//       { params }
//     );
//     setSelecteddata(response.data.data);
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching salary structures:", error);
//     throw error;
//   }
// };

// // useEffect(() => {
// //   getSalaryStructures();
// // }, [superAdminId,selectedBranch,selectedEmployee]);


//   const [filters, setFilters] = useState({
//     role: "",
//     branch: "",
//     employee: ""
//   });

//   const attendanceData = [
//     { id: 1, employee: "Rajeev", role: "Manager", branch: "Delhi", present: 20, absent: 2, halfday: 2 },
//     { id: 2, employee: "Amit", role: "HR", branch: "Mumbai", present: 18, absent: 4, halfday: 2 },
//     { id: 3, employee: "Neha", role: "Agent", branch: "Kolkata", present: 22, absent: 0, halfday: 2 },
//   ];

//   const salaryPerDay = 1000;
//   const halfDayFactor = 0.5;

//   const calculateSalary = (present, halfday) => {
//     return (present + halfday * halfDayFactor) * salaryPerDay;
//   };

//   const handleChange = (e) => {
//     setFilters({ ...filters, [e.target.name]: e.target.value });
//   };





//   const downloadExcel = () => {
//   if (!selectedData || selectedData.length === 0) {
//     alert("No salary data to export");
//     return;
//   }

//   const excelData = selectedData.map((emp, index) => ({
//     "SN": index + 1,
//     "Employee Name": emp.employee?.fullName,
//     "Employee ID": emp.employee?.userId,
//     "Salary Month": emp.salaryMonth,
//     "Working Days": emp.workingDays,
//     "Fuel Allowance": emp.fuelAllowance,
//     "Commission": emp.commission,
//     "HRA": emp.hra,
//     "Total Salary": emp.totalSalary,
//   }));

//   const worksheet = XLSX.utils.json_to_sheet(excelData);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Salary Report");

//   const excelBuffer = XLSX.write(workbook, {
//     bookType: "xlsx",
//     type: "array",
//   });

//   const file = new Blob([excelBuffer], {
//     type:
//       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//   });

//   saveAs(file, `Salary_Report_${Date.now()}.xlsx`);
// };


// const downloadPDF = () => {
//   if (!selectedData || selectedData.length === 0) {
//     alert("No salary data to export");
//     return;
//   }

//   const doc = new jsPDF("l", "mm", "a4");

//   doc.text("Salary Report", 14, 15);

//   const tableHead = [[
//     "SN",
//     "Employee Name",
//     "Employee ID",
//     "Salary Month",
//     "Working Days",
//     "Fuel Allowance",
//     "Commission",
//     "HRA",
//     "Total Salary",
//   ]];

//   const tableBody = selectedData.map((emp, index) => [
//     index + 1,
//     emp.employee?.fullName,
//     emp.employee?.userId,
//     emp.salaryMonth,
//     emp.workingDays,
//     emp.fuelAllowance,
//     emp.commission,
//     emp.hra,
//     emp.totalSalary,
//   ]);

//   autoTable(doc, {
//     head: tableHead,
//     body: tableBody,
//     startY: 20,
//     styles: { fontSize: 9 },
//     theme: "grid",
//   });

//   doc.save(`Salary_Report_${Date.now()}.pdf`);
// };






//   return (
//     <div className="CalculateSalary-container">
//       <h1 className="CalculateSalary-title">Salary Report</h1>

//       {/* Filters */}
//       <div className="SalaryReport-filterSection">
//         <div className="SalaryReport-field">
//             <label>Select Branch *</label>
//             <select
//                 value={selectedBranch}
//                 onChange={(e) => setSelectedBranch(e.target.value)}
//             >
//                 <option value="">Select Branch</option>
//                 {branches.map((emp) => (
//                 <option key={emp.id} value={emp.id}>
//                     {emp.name}- {emp.id}
//                 </option>
//                 ))}
//             </select>
//         </div>
//         <div className="SalaryReport-field">
//             <label>Select Employee*</label>
//            <select
//               value={selectedEmployee}
//               onChange={(e) => setSelectedEmployee(e.target.value)}
//             >
//                 <option value="">Select Employee</option>
//                 {data.map((emp) => (
//                 <option key={emp.id} value={emp.id}>
//                     {emp.fullName}- {emp.id}
//                 </option>
//                 ))}
//             </select>
//         </div>
//       </div>

//       <button className="salaryreport-filter"
//           onClick={getSalaryStructures}
//        >Filter</button>
// <div style={{ display: "flex", gap: "12px", margin: "15px 0" }}>
//   <button
//     className="salaryreport-filter"
//     onClick={downloadExcel}
//   >
//     ⬇️  Excel
//   </button>

//   <button
//     className="salaryreport-filter"
//     onClick={downloadPDF}
//   >
//     ⬇️  PDF
//   </button>
// </div>

//       {/* Table */}
//       <div className="CalculateSalary-tableWrapper">
//         <table className="CalculateSalary-table">
//           <thead>
//             <tr>
//                 <th>S.N.</th>
//                 <th>Employee Name</th>
//                 <th>Employee Id</th>
//                 {/* <th>Branch</th> */}
//                 <th>Salary Month</th>
//                 <th>Working Days</th>
//                 <th>Fuel Allowance (₹)</th>
//                 <th>Commission (₹)</th>
//                 <th>HRA (₹)</th>
//                 <th>Basic Salary (₹)</th>
//             </tr>
//           </thead>
//           <tbody>
//             {selectedData.length === 0 ? (
//                 <tr>
//                 <td colSpan="9" style={{ textAlign: "center" }}>
//                     No data available
//                 </td>
//                 </tr>
//             ) : (
//                 selectedData.map((emp, index) => (
//                 <tr key={emp.id}>
//                     <td>{index + 1}</td>
//                     <td>{emp.employee.fullName}</td>
//                     <td>{emp.employee.userId}</td>
//                     {/* <td>{emp.branchId}</td> */}
//                     <td>{emp.salaryMonth}</td>
//                     <td>{emp.workingDays}</td>
//                     <td>{emp.fuelAllowance}</td>
//                     <td>{emp.commission}</td>
//                     <td>{emp.hra}</td>
//                     <td>₹{emp.totalSalary}</td>
//                 </tr>
//                 ))
//             )}
//             </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default SalaryReport;



import React, { useEffect, useState } from "react";
import "../assets/SalaryReport.css";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";
import { getBranches } from "../redux/slices/branchSlice";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const SalaryReport = () => {
  const dispatch = useDispatch();
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [selectedBranch, setSelectedBranch] = useState("");
  const [selectedData, setSelecteddata] = useState([]);
  
  const { list: data } = useSelector((state) => state.employeeReport);
  const { branches, loading: branchLoading } = useSelector((state) => state.branch);
  
  const superAdminId = localStorage.getItem("adminuserId") || "14";

  useEffect(() => {
    dispatch(fetchEmployeeReport({ page: 1, pageSize: 1000 }));
    dispatch(getBranches({ page: 1, pageSize: 1000 }));
  }, [dispatch]);

  const getSalaryStructures = async () => {
    try {
      const params = { superAdminId };
      if (selectedBranch) params.branchId = selectedBranch;
      if (selectedEmployee) params.employeeId = selectedEmployee;

      const response = await axios.get("https://narrowitsolution.in/api/salary-structures", { params });
      setSelecteddata(response.data.data);
    } catch (error) {
      console.error("Error fetching salary structures:", error);
    }
  };

  const downloadExcel = () => {
    if (!selectedData.length) return alert("No salary data to export");
    const excelData = selectedData.map((emp, index) => ({
      "SN": index + 1,
      "Employee Name": emp.employee?.fullName,
      "Employee ID": emp.employee?.userId,
      "Salary Month": emp.salaryMonth,
      "Working Days": emp.workingDays,
      "Fuel Allowance": emp.fuelAllowance,
      "Commission": emp.commission,
      "HRA": emp.hra,
      "Total Salary": emp.totalSalary,
    }));
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Salary Report");
    XLSX.writeFile(workbook, `Salary_Report_${Date.now()}.xlsx`);
  };

  const downloadPDF = () => {
    if (!selectedData.length) return alert("No salary data to export");
    const doc = new jsPDF("l", "mm", "a4");
    doc.setFontSize(18);
    doc.text("Salary Report", 14, 15);
    const tableBody = selectedData.map((emp, index) => [
      index + 1, emp.employee?.fullName, emp.employee?.userId, emp.salaryMonth,
      emp.workingDays, emp.fuelAllowance, emp.commission, emp.hra, `Rs. ${emp.totalSalary}`
    ]);
    autoTable(doc, {
      head: [["SN", "Employee Name", "ID", "Month", "Days", "Fuel", "Comm.", "HRA", "Total"]],
      body: tableBody,
      startY: 25,
      theme: "striped"
    });
    doc.save(`Salary_Report_${Date.now()}.pdf`);
  };

  return (
    <div className="SalaryReport-container">
      <div className="SalaryReport-header">
        <h1 className="SalaryReport-title">Salary Report</h1>
        <div className="SalaryReport-actions">
          <button className="btn-export excel" onClick={downloadExcel}>Excel</button>
          <button className="btn-export pdf" onClick={downloadPDF}>PDF</button>
        </div>
      </div>

      <div className="SalaryReport-card filter-card">
        <div className="SalaryReport-filterGrid">
          <div className="SalaryReport-field">
            <label>Branch</label>
            <select value={selectedBranch} onChange={(e) => setSelectedBranch(e.target.value)}>
              <option value="">All Branches</option>
              {branches.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
            </select>
          </div>
          <div className="SalaryReport-field">
            <label>Employee</label>
            <select value={selectedEmployee} onChange={(e) => setSelectedEmployee(e.target.value)}>
              <option value="">All Employees</option>
              {data.map((emp) => <option key={emp.id} value={emp.id}>{emp.fullName}</option>)}
            </select>
          </div>
          <div className="SalaryReport-field flex-end">
            <button className="btn-filter" onClick={getSalaryStructures}>Search Report</button>
          </div>
        </div>
      </div>

      <div className="SalaryReport-card table-card">
        <div className="Table-wrapper">
          <table className="Modern-table">
            <thead>
              <tr>
                <th>S.N.</th>
                <th>Employee Name</th>
                <th>Employee Id</th>
                <th>Salary Month</th>
                <th>Working Days</th>
                <th>Fuel (₹)</th>
                <th>Comm. (₹)</th>
                <th>HRA (₹)</th>
                <th>Total Salary (₹)</th>
              </tr>
            </thead>
            <tbody>
              {selectedData.length === 0 ? (
                <tr><td colSpan="9" className="no-data">No records found. Adjust filters to search.</td></tr>
              ) : (
                selectedData.map((emp, index) => (
                  <tr key={emp.id}>
                    <td>{index + 1}</td>
                    <td className="emp-name">{emp.employee?.fullName}</td>
                    <td><span className="badge-id">{emp.employee?.userId}</span></td>
                    <td>{emp.salaryMonth}</td>
                    <td>{emp.workingDays}</td>
                    <td>{emp.fuelAllowance}</td>
                    <td>{emp.commission}</td>
                    <td>{emp.hra}</td>
                    <td className="total-cell">₹{emp.totalSalary?.toLocaleString()}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SalaryReport;